export const EVENT_TYPES = [
  'brake',
  'throttle',
  'steering',
  'idle',
  'cruise',
  'door',
  'lights',
  'custom'
] as const;

export const SCENARIO_TAGS = [
  'idle',
  'cold_start',
  'warm_idle',
  'braking',
  'throttle',
  'flat_ground_20_throttle',
  'cruise',
  'steering',
  'door_test',
  'lights_test',
  'custom'
] as const;

export type EventType = typeof EVENT_TYPES[number];
export type ScenarioTag = typeof SCENARIO_TAGS[number];

export type EventMarker = {
  id: string;
  timestampMs: number;
  eventType: EventType;
  label: string;
  notes?: string;
  durationMs?: number;
};

export type EventCorrelationEvidence = {
  event_type: EventType;
  event_timestamp_ms: number;
  scenario_tag?: ScenarioTag;
  correlation_score: number;
  direction: 'rising' | 'falling' | 'mixed' | 'static';
  lag_ms: number | null;
};

export type ByteFocusRequest = {
  requestId: number;
  canId: number;
  byteIndex: number;
  startBit?: number;
  length?: number;
  endianness?: 'little' | 'big';
  evidence?: EventCorrelationEvidence;
  draft?: {
    signalName?: string;
    category?: string;
    unit?: string;
    notes?: string;
    openDraft?: boolean;
  };
};

export function formatEventType(type: EventType) {
  return type.replace(/_/g, ' ');
}

export function formatScenarioTag(tag: ScenarioTag) {
  return tag.replace(/_/g, ' ');
}

export function makeEventMarker(input: Omit<EventMarker, 'id'>): EventMarker {
  const id = typeof crypto !== 'undefined' && 'randomUUID' in crypto
    ? crypto.randomUUID()
    : `event-${Date.now()}-${Math.random().toString(16).slice(2)}`;
  return {
    ...input,
    id,
    label: input.label.trim() || formatEventType(input.eventType)
  };
}
